module.exports = __webpack_public_path__ + "static/media/SF-10-A.a2e537ef.mp3";